import { InvoiceScanManagerContext } from 'src/sections/invoice_scan_manager/InvoiceScanManagerContext';
import { useContext } from 'use-context-selector';

const useInvoiceScanManager = () => {
  const context = useContext(InvoiceScanManagerContext);
  if (!context)
    throw new Error(
      'Invoice Scan Manager context must be used inside Invoice Scan Manager Context Provider'
    );
  return context;
};

export default useInvoiceScanManager;
